import script from "./UserAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAudit.vue?vue&type=script&setup=true&lang=js"

import "./UserAudit.vue?vue&type=style&index=0&id=22618247&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22618247"]])

export default __exports__